import type { SVGProps } from 'react'

const Search = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 13.5L15.8333 15.8333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.35167 14.5366C12.2153 14.5366 14.5367 12.2152 14.5367 9.35163C14.5367 6.48803 12.2153 4.16663 9.35167 4.16663C6.48807 4.16663 4.16667 6.48803 4.16667 9.35163C4.16667 12.2152 6.48807 14.5366 9.35167 14.5366Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Search
